import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

import { FaToggleOn } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import { CiMail } from "react-icons/ci";
import { GrMap } from "react-icons/gr";
import { FaRegEdit } from "react-icons/fa";
import { TiLocationArrowOutline } from "react-icons/ti";
import {
  IoNotificationsOutline,
  IoWalletOutline,
  IoHelpCircleOutline,
} from "react-icons/io5";
import { CiHeart } from "react-icons/ci";
import { PiAppWindowThin } from "react-icons/pi";
import { GoPencil, GoSignOut } from "react-icons/go";

import { SlBookOpen } from "react-icons/sl";
import CountryDisplay from "../components/countrylookup";

const CircularFlag = ({ countryCode }) => {
  const url = `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;
  return (
    <div className="w-6 h-6 rounded-full  p-0.5 bg-black flex items-center justify-center">
      <img
        src={url}
        alt={`${countryCode} Flag`}
        className="object-cover w-full h-full rounded-full"
      />
    </div>
  );
};

export default function Settings() {
  const { user } = useAuth();

  return (
    <div>
      {/* HEADER & TABS */}
      <div style={{ backgroundColor: "rgb(22, 19, 22)" }}>
        <div className="flex items-center justify-between w-full pt-2 pb-2 pl-4 pr-4">
          <div className="mx-auto">
            <p className="ml-6 text-md font-medium text-gray-200">My Account</p>
          </div>
        </div>
      </div>

      <div className="h-[85vh] overflow-y-scroll scroll-smooth">
        <div style={{ backgroundColor: "rgb(22, 19, 22)" }}>
          <div className="px-4 pt-6 pb-4">
            <p className="text-xl text-gray-200">{user?.name}</p>
            <p className="text-md text-gray-300">{user?.v_mail}</p>
          </div>
        </div>

        <div>
          <div className="px-4 mt-4">
            <p className="text-gray-800 text-lg font-semibold">Notifications</p>
            <div className="py-4">
              <div className="flex justify-center">
                <div className="flex-1 flex gap-1 items-center">
                  <CiMail className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">
                    My Notifications
                  </p>
                </div>
                <MdKeyboardArrowRight className="text-gray-800" size={25} />
              </div>

              <div className="flex justify-center mt-3">
                <div className="flex-1 flex gap-1 items-center">
                  <IoNotificationsOutline className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">
                    Receive Notifications?
                  </p>
                </div>
                <FaToggleOn className="text-blue-500" size={32} />
              </div>
            </div>
          </div>

          <div className="px-4 mt-4">
            <p className="text-gray-800 text-lg font-semibold">
              Location Settings
            </p>
            <div className="py-4">
              <div className="flex justify-center">
                <div className="flex-1 flex gap-1 items-center">
                  <GrMap className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">
                    My Location
                  </p>
                </div>
                <div className="flex gap-1 items-center font-medium text-blue-500">
                  {user?.location}
                  <FaRegEdit size={25} />
                </div>
              </div>

              <div className="flex justify-center mt-4">
                <div className="flex-1 flex gap-1 items-center">
                  <CircularFlag
                    countryCode={user?.country}
                    className="text-gray-200"
                  />
                  <p className="text-gray-800 text-md font-Medium">
                    My Country
                  </p>
                </div>
                <div className="flex gap-1 items-center font-medium text-blue-500">
                  {/* {user?.country} */}
                  {/* <p>
                    United States
                  </p> */}
                  <CountryDisplay />
                  <FaRegEdit size={25} />
                </div>
              </div>

              <div className="flex justify-center mt-4">
                <div className="flex-1 flex gap-1 items-center">
                  <TiLocationArrowOutline className="text-gray-800" size={25} />
                  <p className="text-gray-800 text-md font-Medium">Location</p>
                </div>
              </div>
            </div>
          </div>

          <div className="px-4 mt-4">
            <p className="text-gray-800 text-lg font-semibold">Notifications</p>
            <div className="py-4">
              <div className="flex justify-center">
                <div className="flex-1 flex gap-1 items-center">
                  <CiHeart className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">
                    My Favourites
                  </p>
                </div>
                <MdKeyboardArrowRight className="text-gray-800" size={25} />
              </div>

              <div className="flex justify-center mt-4">
                <div className="flex-1 flex gap-1 items-center">
                  <IoWalletOutline className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">
                    Saved Payment Methods
                  </p>
                </div>
                <MdKeyboardArrowRight className="text-gray-800" size={25} />
              </div>

              <div className="flex justify-center mt-4">
                <div className="flex-1 flex gap-1 items-center">
                  <PiAppWindowThin className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">
                    Change App Icon
                  </p>
                </div>
                <MdKeyboardArrowRight className="text-gray-800" size={25} />
              </div>
            </div>
          </div>

          <div className="px-4 mt-4">
            <p className="text-gray-800 text-lg font-semibold">
              Help & Guidance
            </p>
            <div className="pt-4">
              <div className="flex justify-center">
                <div className="flex-1 flex gap-1 items-center">
                  <IoHelpCircleOutline className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">Need Help</p>
                </div>
                <MdKeyboardArrowRight className="text-gray-800" size={25} />
              </div>

              <div className="flex justify-center mt-4">
                <div className="flex-1 flex gap-1 items-center">
                  <GoPencil className="text-gray-800" size={22} />
                  <p className="text-gray-800 text-md font-Medium">
                    Give Us Feedback
                  </p>
                </div>
                <MdKeyboardArrowRight className="text-gray-800" size={25} />
              </div>

              <div className="flex justify-center mt-4">
                <div className="flex-1 flex gap-1 items-center">
                  <SlBookOpen className="text-gray-400" size={22} />
                  <p className="text-gray-800 text-md font-Medium">Legal</p>
                </div>
                <MdKeyboardArrowRight className="text-gray-800" size={25} />
              </div>

              <div className="flex justify-center mt-8 pb-4">
                <div className="flex-1 flex gap-1 items-center">
                  <GoSignOut className="text-red-800" size={22} />
                  <p className="text-red-800 text-md font-Medium">Sign Out</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
